$(function(){
    $('[rel="popover"]').popover({
        container: '.job-container',
        placement: 'right',
        html: true,
        content: function () {
            var clone = $($(this).data('popover-content')).clone(true).removeClass('hide');
            return clone;
        }
    }).click(function(e) {
        e.preventDefault();
    });

    $(document).on('click', function (e) {
        $('[rel="popover"]').each(function () {
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                $(this).popover('hide');
            }
        });
    });
});

function getDetailsFromJobRow(el) {
    var args = el.data('id').split('-'),
        result = {};

    if (args.length >= 3) {
        if (args[0] == 'note') {
            result = {
                type: args[0],
                driverId: args[1],
                noteId: args[2]
            };
        } else {
            result = {
                type: args[0],
                jobId: args[1],
                job2ItineryId: args[2]
            };
        }

        if (result.type == 'duplicate' && args.length == 4) {
            result.dseiId = args[3];
        }
    }

    return result;
}